import React, {ReactNode} from "react";
import styled from "styled-components";

interface MentorCardSectionItemProps {
    children: ReactNode;
    last?: boolean;
    label?: string;
}

const Label = styled.h3`
    color: #5d5f70;
    text-transform: uppercase;
    margin-bottom: 5px;
    padding: 0 20px;
    font-size: 0.875rem;
`;

const Content = styled.div<{last?: boolean}>`
    margin-bottom: ${(props) => (props.last ? "20px" : "15px")};
    padding: 0 20px;
    font-size: 1rem;

    /* Break long words and URLs */
    overflow-wrap: break-word;
    word-wrap: break-word;
`;

export const MentorCardSectionItem: React.FC<MentorCardSectionItemProps> = ({
    children,
    last = false,
    label = "",
}) => (
    <div>
        {label ? <Label>{label}</Label> : null}
        <Content last={last}>{children}</Content>
    </div>
);

